export default __webpack_public_path__ + "static/media/demo.658e6025.png";